
import { ISystem } from "@initia-digital/types/system";
import { EquipmentClassType } from "@initia-digital/types/work-and-safety";


export const CONFIG = {
    DEFAULT_PAGE_CONFIG: {
        appName: 'Work and Safety',
        appVersion: process.env.PACKAGE_VERSION
    },
    CDN_BASE_URL: `https://cdn.public.initia-digital.co.nz`,
    SF_URL: `https://initianz.my.salesforce.com`,
    INITIA_SYSTEMS_APP_BAR_AND_PANEL_VISIBILITY_FILTER: (system: ISystem) => system.name !== 'Work and Safety',
    EQUIPMENT_CLASS_TYPES: [
        {
            type: 'INVESTIGATION' as EquipmentClassType,
            header: 'Investigation'
        },
        {
            type: 'MONITORING' as EquipmentClassType,
            header: 'Monitoring'
        },
        {
            type: 'GEOLOCATION' as EquipmentClassType,
            header: 'Geolocation'
        },
        {
            type: 'PPE_GENERAL' as EquipmentClassType,
            header: 'Fundamental PPE'
        },
        {
            type: 'PPE_SPECIFIC' as EquipmentClassType,
            header: 'Special PPE'
        }
    ],
    PLAN_STEPS: [
        {
            'value': 'workbrief',
            'label': 'Workbrief',
            'query': '?stage=workbrief'
        },
        {
            'value': 'services',
            'label': 'Services',
            'query': '?stage=services'
        },
        {
            'value': 'contactsAndBookings',
            'label': 'Contacts and Bookings',
            'query': '?stage=contactsAndBookings'
        },
        {
            'value': 'sitePlansAndPermits',
            'label': 'Other Files',
            'query': '?stage=sitePlansAndPermits'
        },
        {
            'value': 'hazardAssessment',
            'label': 'Hazard Assessment',
            'query': '?stage=hazardAssessment'
        }, 
        {
            'value': 'ppeAndTools',
            'label': 'PPE and Tools',
            'query': '?stage=ppeAndTools'
        }, 
        {
            'value': 'action',
            'label': 'Action',
            'query': '?stage=action'
        }
    ],
    PRESTART_STEPS: [
        {
            'value': 'start',
            'label': 'Start',
            'query': '?stage=start'
        },
        {
            'value': 'planReview',
            'label': 'Review the plans',
            'query': '?stage=planReview'
        },
        {
            'value': 'hazardObservations',
            'label': 'Hazard Observations',
            'query': '?stage=hazardObservations'
        },
        {
            'value': 'workingWithOthers',
            'label': 'Working with Others',
            'query': '?stage=workingWithOthers'
        }
        ,
        {
            'value': 'closure',
            'label': 'Closure and contacts',
            'query': '?stage=closure'
        }
    ]
} as const;